import { getCommandPort } from './commandPorts';
import {
  ingestOutcomeSucceeded,
  ingestSingleCommand,
  shouldUseInboxIngest,
} from './ingestDeviceCommands';
import { toOnlineCommandItem } from './onlineCommandItem';
import type { SyncEntity, SyncOperation } from './syncTypes';

export type DispatchOnlineCommandParams = {
  entity: SyncEntity;
  operation: SyncOperation;
  payload: Record<string, unknown>;
};

function branchIdFromPayload(payload: Record<string, unknown>): string | null {
  const branchId = payload.branchId;
  return typeof branchId === 'string' && branchId.trim().length > 0 ? branchId.trim() : null;
}

/** Camino online del tubo: ingest (hot set) o RPC. Sin cola. */
export async function dispatchOnlineCommand(params: DispatchOnlineCommandParams): Promise<void> {
  const { entity, operation, payload } = params;
  const port = getCommandPort(entity);
  if (!port) {
    throw new Error(`dispatchOnlineCommand: sin puerto para entity ${entity}`);
  }

  const prepared = port.prepareOnlinePayload(operation, payload);
  const item = toOnlineCommandItem(entity, operation, prepared);

  if (await shouldUseInboxIngest(entity)) {
    const ingestResult = await ingestSingleCommand(
      entity,
      operation,
      prepared,
      branchIdFromPayload(prepared),
    );

    if (ingestResult.error !== 'inbox_disabled') {
      if (ingestOutcomeSucceeded(ingestResult.outcome)) {
        await port.afterServerApply?.(item);
        return;
      }
      if (ingestResult.outcome === 'rejected') {
        throw new Error(ingestResult.error ?? 'ingest_rejected');
      }
      throw new Error(ingestResult.error ?? `ingest_${ingestResult.outcome}`);
    }
  }

  const result = await port.applyViaRpc(item);
  if (!result.ok) {
    throw new Error(result.error);
  }
}
